/* ============================================
   STICKY ATC — incolla in assets/sticky-atc.js
   ============================================ */

(function () {
  function init() {
    const stickyBar = document.getElementById('sticky-atc');
    if (!stickyBar) return;

    // Cerca il pulsante "Aggiungi al carrello" originale
    const mainBtn = document.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
    if (!mainBtn) return;

    function onScroll() {
      const rect = mainBtn.getBoundingClientRect();
      // Mostra lo sticky quando il pulsante principale esce dalla viewport
      if (rect.bottom < 0) {
        stickyBar.classList.add('sticky-atc--visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('sticky-atc--visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
